


























































































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component({
  components: {}
})
export default class PlantingDensity extends Vue {
  private plantingDensity: any = null
  private plantingSpaceY: any = null
  private plantingSpaceX: any = null

  @Prop() private masterData!: any

  private get changeMasterData (): any {
    return this.masterData
  }

  @Watch('changeMasterData')
  onChangeMasterData (data: any) {
    this.plantingSpaceY = data.planting_space_y
    this.plantingSpaceX = data.planting_space_x
    this.plantingDensity = data.planting_density
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number|string) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  private displayValue (value: string|number) {
    return value !== null && value !== undefined ? this.toLocaleString(value) : '-'
  }
}
